import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxAsset/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxAsset/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/sxAsset/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/sxAsset/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/sxAsset/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function damObj (id) {
  return axios({
    url: `/sxAsset/damage/${id}`,
    method: 'GET'
    // data: {
    //   ...params
    // }
  })
}
